import { render, staticRenderFns } from "./NBLock.vue?vue&type=template&id=522953ec&scoped=true"
import script from "./NBLock.vue?vue&type=script&lang=js"
export * from "./NBLock.vue?vue&type=script&lang=js"
import style0 from "./NBLock.vue?vue&type=style&index=0&id=522953ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522953ec",
  null
  
)

export default component.exports